/**
 * Hook para contar emails não lidos (usado no Header)
 */

import { useQuery } from '@tanstack/react-query';
import { getEmailUnreadCount } from '@/modules/email/shared/services/emailService';

export const useEmailUnreadCount = () => {
  return useQuery({
    queryKey: ['email-unread-count'],
    queryFn: ({ signal }) => getEmailUnreadCount(signal),
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
};
